define([], function () {
    controller.$inject = ['$scope', '$rootScope', 'AuthService', 'UserService', '$state', 'WorkspaceService', '$localStorage', '$document', '$window', '$element', '$timeout', 'LanguageService', 'SuiteTheme'];

    function controller($scope, $rootScope, AuthService, UserService, $state, WorkspaceService, $localStorage, $document, $window, $element, $timeout, LanguageService, SuiteTheme) {
        var ctrl = this;
        $scope.maxMembers = 1;
        $scope.menuOpen = false;
        $scope.menuStyle = {display: 'none'};
        $scope.themePreference = SuiteTheme.getPreference();
        $scope.themeOptions = [
            {id: 'light', label: 'suite.theme.switchToLight', icon: 'ti-sun'},
            {id: 'dark', label: 'suite.theme.switchToDark', icon: 'ti-moon'},
            {id: 'system', label: 'suite.theme.system', icon: 'ti-device-desktop'}
        ];
        var triggerElement;
        var menuElement;

        $scope.setThemePreference = function (preference) {
            SuiteTheme.setPreference(preference);
            $scope.themePreference = SuiteTheme.getPreference();
        };

        $scope.$on('suiteThemeChanged', function (event, mode, preference) {
            $scope.themePreference = preference || SuiteTheme.getPreference();
        });

        ctrl.$onChanges = function (changes) {
            if (changes.selectedLang && changes.selectedLang.currentValue) {
                ctrl.language = changes.selectedLang.currentValue;
            }
        };

        ctrl.changeLanguage = function () {
            if (ctrl.language && ctrl.onSwitchLang) {
                ctrl.onSwitchLang({language: ctrl.language});
            }
            $scope.closeMenu();
        };
        ctrl.languageName = function (language) {
            return LanguageService.getLanguageName(language);
        };

        function positionMenu() {
            if (!$scope.menuOpen || !triggerElement || !menuElement) {
                return;
            }
            var trigger = triggerElement.getBoundingClientRect();
            var menuWidth = menuElement.offsetWidth;
            var menuHeight = menuElement.offsetHeight;
            var left = Math.max(8, Math.min(trigger.left, $window.innerWidth - menuWidth - 8));
            var top = trigger.bottom + 8;
            if (top + menuHeight > $window.innerHeight - 8) {
                top = Math.max(8, trigger.top - menuHeight - 8);
            }
            $scope.menuStyle = {display: 'block', left: left + 'px', top: top + 'px'};
        }

        $scope.toggleMenu = function () {
            $scope.menuOpen = !$scope.menuOpen;
            if ($scope.menuOpen) {
                $scope.menuStyle = {display: 'block'};
                $timeout(positionMenu, 0);
            } else {
                $scope.menuStyle = {display: 'none'};
            }
        };

        $scope.closeMenu = function () {
            $scope.menuOpen = false;
            $scope.menuStyle = {display: 'none'};
        };

        $scope.navigate = function (state) {
            $scope.closeMenu();
            $state.go(state);
        };

        function onDocumentClick(event) {
            if ($scope.menuOpen && !menuElement.contains(event.target) && !triggerElement.contains(event.target)) {
                $scope.$applyAsync($scope.closeMenu);
            }
        }

        function onDocumentKeydown(event) {
            if ($scope.menuOpen && event.key === 'Escape') {
                $scope.$applyAsync($scope.closeMenu);
                triggerElement.focus();
            }
        }

        this.$postLink = function () {
            triggerElement = $element[0].querySelector('.st-menu-multi-account__trigger');
            menuElement = $element[0].querySelector('.st-account-dropdown');
            $document[0].body.appendChild(menuElement);
            $document[0].addEventListener('click', onDocumentClick, true);
            $document[0].addEventListener('keydown', onDocumentKeydown, true);
            $window.addEventListener('resize', positionMenu);
            $window.addEventListener('scroll', positionMenu, true);
        };

        $scope.$on('$destroy', function () {
            $document[0].removeEventListener('click', onDocumentClick, true);
            $document[0].removeEventListener('keydown', onDocumentKeydown, true);
            $window.removeEventListener('resize', positionMenu);
            $window.removeEventListener('scroll', positionMenu, true);
            if (menuElement && menuElement.parentNode) {
                menuElement.parentNode.removeChild(menuElement);
            }
        });

        function loadMemberLimit() {
            if (!AuthService.isAuthenticated()) {
                return;
            }
            UserService.limits()
                .then(function (res) {
                    if (res && res.data && res.data.limits && res.data.limits.length) {
                        angular.forEach(res.data.limits, function (service) {
                            if (service.alias === 'workspace-users-limit') {
                                // $scope.maxMembers = (service.qtyAllowed === 1) ? service.qtyAllowed : service.qtyAllowed + 1;
                                $scope.maxMembers = service.qtyAllowed + 1;
                            }
                        });
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return null;
                });
        }

        $scope.workspaces = [];

        $scope.$watch('$ctrl.currentUser.workspace.id', function (newVal) {
            $scope.activeWorkspaceId = newVal;
            $scope.currentUser = $localStorage.currentUser;
            getAllWorkspaces();
            getInvitations();
            loadMemberLimit();
        });

        $rootScope.$on('$stateChangeStart', function () {
            $scope.closeMenu();
            if (AuthService.isAuthenticated()) {
                getInvitations();
            }
        });

        function getInvitations() {
            return WorkspaceService
                .getInvitations()
                .then(function (res) {
                    if (res) {
                        $scope.invitations = res;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        function getAllWorkspaces() {
            WorkspaceService.getAllWorkspaces()
                .then(function (res) {
                    if (res && res.workspaces && res.workspaces.length) {
                        $scope.workspaces = res.workspaces;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        }

        $scope.switchWorkspace = function (workspace) {
            $scope.closeMenu();
            if (workspace.id === $scope.activeWorkspaceId) {
                return;
            }
            WorkspaceService.setWorkspace(workspace);
            $rootScope.$broadcast('switchWorkSpace', $localStorage.currentUser);
            $state.reload();
        };

        $scope.$on('invitation-accept', function () {
            getAllWorkspaces();
        });

        $scope.logout = function () {
            $scope.closeMenu();
            AuthService.logout();
            setTimeout(function () {
                $state.go('app.welcome', {}, {
                    reload: true
                });
            }, 1000);
            if (typeof zE !== 'undefined' && zE) {
                zE('messenger', 'logoutUser');
            }
        };
    }

    return {
        templateUrl: 'app/modules/template/components/st-menu-multi-account/st-menu-multi-account.component.html',
        controller: controller,
        bindings: {
            currentUser: '<',
            languages: '<',
            selectedLang: '<',
            onSwitchLang: '&',
            expanded: '<'
        }
    };
});
